import { gql } from '@apollo/client';

export const ContractCoreFields = gql`
  fragment ContractCoreFields on Contract {
    id
    ownerId
    pdfUrl
    isAgreedTo
    agreedAt
    contractTemplateId
    tenantId
    clientId
    validUntil
    isActive
    html
    contractType
  }
`;

export const AGREE_TO_CONTRACT = gql`
  mutation AgreeToContract($contractId: String!, $signature: String) {
    agreeToContract(contractId: $contractId, signature: $signature) {
      ...ContractCoreFields
    }
  }
  ${ContractCoreFields}
`;

export const GET_CONTRACT = gql`
  query GetContract($id: String!) {
    getContract(id: $id) {
      ...ContractCoreFields
    }
  }
  ${ContractCoreFields}
`;

export const VERIFY_CONTRACT_STATUS = gql`
  query VerifyContractStatus {
    verifyContractStatus {
      contractId
      contractTemplateId
      tenantId
      isAgreedTo
      contractDescription
      agreedAt
      validUntil
      notes
      requiresAction
      requiresActionDescription
      contractType
    }
  }
`;

export const GET_CONTRACTS_BY_OWNER_ID = gql`
  query GetContractsByOwnerId($ownerId: String!, $tenantId: String!, $activeOnly: Boolean) {
    getContractsByOwnerId(ownerId: $ownerId, tenantId: $tenantId, activeOnly: $activeOnly) {
      ...ContractCoreFields
    }
  }
  ${ContractCoreFields}
`;
